const useLoggedInUser = () => {
  const loggedIn:any = localStorage.getItem('__cbuN');
  return loggedIn ? JSON.parse(loggedIn) : null;
}
export default useLoggedInUser
